import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http'
import { SubtipoCruce } from '../models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubtipoCruceService {

  private ENDPOINT = environment.ENDPOINTS.SUBTIPO;
  constructor(private http:HttpClient) { }

  getSubtipos(){
    return this.http.get<SubtipoCruce[]>(this.ENDPOINT);
  }

  getSubtipo(id: number){
    return this.http.get<SubtipoCruce>(this.ENDPOINT + `/${id}`);
  }

  getSubtipoChilds(){
    return this.http.get<SubtipoCruce>(environment.ENDPOINTS.API + `/incidenciasHijos`);
  }
}
